import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Primary Bedroom (Phase 13A). Deliberately a separate config from
 * bedroom.ts (not a "same form, bigger multiplier") since the primary
 * bedroom's real-world scope differs: a dedicated closet-system tier
 * (reach-in upgrade vs. a full walk-in closet system, priced well above
 * bedroom's generic built-ins) and an optional sitting area, on top of
 * the same optional ensuite-rough-in plumbing option bedroom.ts also
 * offers (a primary bedroom is the most common place homeowners add
 * ensuite rough-in for).
 */
export const calculatePrimaryBedroom = createInteriorRoomCalculator({
  projectType: "primary_bedroom",
  anchorItemId: "primary_bedroom_base_renovation",
  tierFeatures: [
    {
      answerKey: "primary_bedroom_flooring_type",
      itemIdByTier: { not_changing: null, basic: "primary_bedroom_flooring_basic", mid_range: "primary_bedroom_flooring_mid", premium: "primary_bedroom_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "primary_bedroom_painting",
      itemIdByTier: { not_included: null, walls_only: "primary_bedroom_painting_walls", full_room: "primary_bedroom_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "primary_bedroom_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "primary_bedroom_trim_standard", premium_millwork: "primary_bedroom_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "primary_bedroom_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "primary_bedroom_lighting_standard", statement_lighting: "primary_bedroom_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "primary_bedroom_built_ins",
      itemIdByTier: { none: null, standard: "primary_bedroom_built_ins_standard", custom: "primary_bedroom_built_ins_custom" },
      excludedMessage: "No additional built-in storage was requested - excluded from this estimate (see closet system for the walk-in closet itself)."
    },
    {
      answerKey: "primary_bedroom_windows_doors",
      itemIdByTier: { none: null, replace_existing: "primary_bedroom_windows_doors_replace", add_new: "primary_bedroom_windows_doors_add" },
      excludedMessage: "No window or door changes were requested - excluded from this estimate."
    },
    {
      answerKey: "primary_bedroom_closet_system",
      itemIdByTier: {
        none: null,
        reach_in_upgrade: "primary_bedroom_closet_reach_in_upgrade",
        walk_in_system: "primary_bedroom_closet_walk_in_system"
      },
      excludedMessage: "No closet system upgrade was requested - excluded from this estimate."
    }
  ],
  booleanFeatures: [
    { answerKey: "primary_bedroom_sitting_area", itemId: "primary_bedroom_sitting_area", excludedMessage: "A sitting area was not requested - excluded from this estimate." },
    { answerKey: "primary_bedroom_ensuite_rough_in", itemId: "primary_bedroom_ensuite_rough_in", excludedMessage: "No future-ensuite plumbing rough-in was requested - excluded from this estimate." }
  ],
  electricalItemId: "primary_bedroom_electrical",
  demolitionItemId: "primary_bedroom_demolition",
  accessibilityItemId: "primary_bedroom_accessibility",
  permitDesignItemId: "primary_bedroom_permit_design"
});
